module.exports = __webpack_public_path__ + "static/colgadas-008-c8ee8679b15bba9bc3c32ed357ad9c7b.jpg";